const lang = {
"6063460":"收起",
"7221059":"振动曲线",
"17696085":"下包络线",
"18489697":"已上报",
"29623699":"全屏",
"38175149":"突变",
"86795130":"去粗差",
"94832441":"请输入注册时的手机号码",
"ba80efd":"菜单设置",
"5a936b7f":"展开",
"abfe9512":"保存",
"f1daad2b":"重点监控",
"d80bf0cd":"分组预览",
"fc4711bc":"天气",
"6c8fbd7f":"合作单位",
"4de11e23":"首页",
"8da0207b":"大屏",
"73d15d59":"报警",
"739eccce":"没有报警",
"cb98e8ce":"个人设置",
"f112895":"新建项目",
"b0783bf7":"我的项目",
"e96a3334":"企业切换",
"b2ccf184":"更换皮肤",
"d7343e9e":"语言切换",
"222aab7d":"帮助文档",
"d44d6010":"意见反馈",
"f91e25f3":"帮助手册",
"f03f539c":"常用公式",
"fe098bf5":"一键检查",
"2c69ab15":"退出",
"2358b7a7":"我们珍视您的每一条反馈，描述越精确的问题，更易得到解决",
"c434cbbe":"中交蓝",
"bdc48e74":"繁星黑",
"bcd2a796":"奢雅金",
"79e8c76":"公路长大桥建设公家工程研究中心",
"1312aea9":"藤州浔江大桥",
"4cf33970":"未处理",
"8ce3cd0d":"忽略",
"8553a91c":"已处理",
"b41a2a03":"按enter键搜索",
"3a2a1316":"添加项目",
"f8b859ce":"项目列表",
"db8198ce":"藤州浔江大桥健康监测系统",
"d9a46c29":"默认",
"d1970fcc":"使用指南",
"95b9a9b8":"继续了解",
"fec1495c":"立即体验",
"67677b3d":"数据",
"b078a763":"可用",
"487dc44":"手动标记异常",
"9afe07e1":"超量程",
"24233ad9":"无单位",
"98ddb44d":"缺水",
"200c228":"补录",
"5af06a64":"补录且突变",
"a8b74ad3":"补录且超量程",
"166a77eb":"补录且无单位",
"a4814c15":"最近一天",
"71b7be35":"最近一周",
"fd315ee9":"最近一月",
"9b943197":"按次",
"989a44f2":"每小时均值",
"6c8f55bf":"每天均值",
"7d50312":"每周均值",
"3b5a789b":"每分钟均值",
"a47ea9f7":"弱",
"80c1453f":"中等",
"33ac707f":"强",
"cda435c8":"密码由6-20位数字加字母加特殊字符组成",
"11a9f092":"卡尔曼滤波平滑",
"7f43b9df":"浮动系数",
"753f803c":"多项式",
"f8ab0bbb":"上包络线",
"29c56664":"缩放系数",
"8555470e":"处理之后的值",
"7f0c746d":"操作成功",
"2dfbef39":"非常抱歉，您目前使用的是免费版本，暂不支持此功能。",
"74b7a51f":"如想升级服务，请联系我们的服务人员",
"ad5ee90f":"非常抱歉，您访问的页面出错了，请稍后再试",
"70e0cf4d":"返回首页",
"89fbadbd":"应用数据",
"2e096223":"测点曲线",
"b23f26d0":"解算数据",
"324931cd":"原始数据",
"5cc888aa":"北斗信息",
"479f2f39":"使用微信扫码登录",
"ee361f3a":"欢迎登录平台",
"2695488c":"请输入用户名",
"25c895d5":"请输入密码",
"4f69cbc9":"忘记密码",
"c3d5471":"请输入验证码",
"e0b582a3":"输入验证码",
"59cf86cb":"获取验证码",
"ebc816db":"S后重新获取",
"b65de496":"换一组",
"a81f826f":"记住密码",
"d2c1a316":"登录",
"7b863a2d":"注册新用户",
"3fbc6797":"APP二维码下载",
"a4639803":"推荐使用",
"b8185132":"或",
"81e2aae7":"用户注册",
"89136b9b":"请输入手机号码",
"313122ff":"后重新获取",
"27eca84":"请输入短信验证码",
"ac769e4a":"设置6至20位登录密码",
"a9aef039":"确认密码",
"8bb6dc3":"勾选同意",
"459ecdd3":"用户服务协议",
"8899f89f":"注册",
"6fe0f093":"使用已有帐户登录",
"198b137e":"找回密码",
"49721de0":"重设密码",
"efc07278":"返回登录",
"fb5c13f3":"微信登录",
"dbbaf16e":"用户登录",
"bb5480f3":"扫描访问小程序",
"64ed141c":"我已阅读并同意",
"fd4e3ce3":"加载失败",
"afa12da6":"不能包含特殊字符",
"69e70923":"密码不能少于6位数",
"f8db5b5e":"用户名不能为空",
"fc7c438d":"不能为空",
"e05a219e":"密码不一致",
"7862cd02":"发送成功",
"f3d9187d":"请勾选用户协议",
"955f5eca":"备案序号",
"7ea346da":"技术支持"
}
export default lang